const fireplaces = [
  "fireplace.webp",
  "fireplace-chair.webp",
  "fireplace-rounded-gray.JPG",
  "fireplace-lareira.jpg",
  "IMG_0127.jpg",
  "IMG_0128.jpg",
  "IMG_4062.JPG",
];

const outdoorKitchen = [
  "IMG_1369.jpg",
  "IMG_1371.jpg",
  "IMG_5229.jpg",
  "IMG_5323.jpg",
  "IMG_5391.jpg",
  "IMG_5392.jpg",
  "R6M27970.JPG",
  "R6M27979.JPG",
]

const patiosImages = [
  "patio-blocks.jpg",
  "patio-blue-house.JPG",
  "patio-house.jpg",
  "patio-pool.JPG",
];

const stepsImage = [
  "step-and-wall.JPG",
  "step-building.JPG",
  "steps-garden.webp",
  "steps-lightning.webp",
  "steps-walls.webp",
]

const walkImages = [
  "IMG_3961.jpg",
  "IMG_4070.jpg",
  "IMG_4918.jpg",
  "IMG_9718.jpg",
  "IMG_9720.jpg"
]

const wallsImages = [
  "full-house.JPG",
  "wall-middle.JPG",
  "steps-walls.webp"
]

export const projects = [
  ...fireplaces.map((img, index) => ({
    id: `fireplace${String(index + 1)}`,
    img: `assets/images/services/fireplaces/${img}`,
    title: "Fireplace",
    category: "Fireplace",
  })),
  ...outdoorKitchen.map((img, index) => ({
    id: `outdoor-kitchen${String(index + 1)}`,
    img: `assets/images/services/${encodeURIComponent("outdoor Kitchen")}/${img}`,
    title: "Outdoor Kitchen",
    category: "Outdoor Kitchen",
  })),
  ...patiosImages.map((img, index) => ({
    id: `patio${String(index + 1)}`,
    img: `assets/images/services/Patios/${img}`,
    title: "Patio",
    category: "Patio",
  })),
  ...stepsImage.map((img, index) => ({
    id: `steps${String(index + 1)}`,
    img: `assets/images/services/Steps/${img}`,
    title: "Steps",
    category: "Steps",
  })),
  ...walkImages.map((img, index) => ({
    id: `walk${String(index + 1)}`,
    img: `assets/images/services/Walk/${img}`,
    title: "Walk",
    category: "Walk",
  })),
  ...wallsImages.map((img, index) => ({
    id: `walls${String(index + 1)}`,
    img: `assets/images/services/Walls/${img}`,
    title: "Walls",
    category: "Walls",
  })),
];